// Generate random but consistent colors for player avatars
export const getAvatarColor = (name) => {
	const colors = [
		'bg-red-500',
		'bg-blue-500',
		'bg-green-500',
		'bg-yellow-500',
		'bg-purple-500',
		'bg-pink-500',
		'bg-indigo-500',
		'bg-teal-500',
	];

	// Use the name to generate a consistent index
	const index = name.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) % colors.length;
	return colors[index];
};

// Get initials for the avatar
export const getInitials = (name) => {
	return name.substring(0, 2).toUpperCase();
};
